import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
export function fetchAddressSuggestions(_x) {
  return _fetchAddressSuggestions.apply(this, arguments);
}
function _fetchAddressSuggestions() {
  _fetchAddressSuggestions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(query) {
    var accessToken, geocodingUrl, endpoint, params, response, data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(!query || query.length < 3)) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return", []);
        case 2:
          _context.prev = 2;
          accessToken = process.env.VUE_APP_MAPBOX_ACCESS_TOKEN;
          geocodingUrl = process.env.VUE_APP_MAPBOX_GEOCODING_API_URL;
          endpoint = "".concat(geocodingUrl, "/mapbox.places/").concat(encodeURIComponent(query), ".json");
          params = new URLSearchParams({
            access_token: accessToken,
            types: "address",
            limit: 10,
            autocomplete: true
          });
          _context.next = 9;
          return fetch("".concat(endpoint, "?").concat(params));
        case 9:
          response = _context.sent;
          _context.next = 12;
          return response.json();
        case 12:
          data = _context.sent;
          return _context.abrupt("return", data.features || []);
        case 16:
          _context.prev = 16;
          _context.t0 = _context["catch"](2);
          console.error("Mapbox geocoding error:", _context.t0);
          return _context.abrupt("return", []);
        case 20:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 16]]);
  }));
  return _fetchAddressSuggestions.apply(this, arguments);
}
export function parseAddressFromMapbox(selectedAddress, listCountries, displayedListStates) {
  if (!selectedAddress || !selectedAddress.context) {
    return null;
  }
  var street = selectedAddress.text || "";
  var streetNumber = selectedAddress.address || "";
  var fullStreet = streetNumber ? "".concat(streetNumber, " ").concat(street) : street;
  var addressData = {
    street: fullStreet,
    zip: null,
    city: null,
    country: null,
    state: null
  };
  selectedAddress.context.forEach(function (item) {
    if (item.id.startsWith("postcode")) {
      addressData.zip = item.text;
    } else if (item.id.startsWith("place")) {
      addressData.city = item.text;
    } else if (item.id.startsWith("country")) {
      if (listCountries && listCountries.length > 0) {
        var countryName = item.text;
        var matchingCountry = listCountries.find(function (c) {
          return c.printable_name && c.printable_name.toLowerCase() === countryName.toLowerCase() || c.iso && item.short_code && c.iso.toLowerCase() === item.short_code.toLowerCase();
        });
        addressData.country = matchingCountry || null;
      }
    } else if (item.id.startsWith("region")) {
      if (displayedListStates && displayedListStates.length > 0) {
        var stateName = item.text;
        var matchingState = displayedListStates.find(function (s) {
          return s.state_label && s.state_label.toLowerCase() === stateName.toLowerCase();
        });
        addressData.state = matchingState || null;
      }
    }
  });
  return addressData;
}
export function getCurrentPositionAddress() {
  return _getCurrentPositionAddress.apply(this, arguments);
}
function _getCurrentPositionAddress() {
  _getCurrentPositionAddress = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.abrupt("return", new Promise(function (resolve, reject) {
            if (!navigator.geolocation) {
              reject(new Error("Geolocation is not supported by your browser"));
              return;
            }
            navigator.geolocation.getCurrentPosition(/*#__PURE__*/function () {
              var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(position) {
                var _position$coords, latitude, longitude, accuracy, accessToken, geocodingUrl, endpoint, params, response, data;
                return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.prev = 0;
                      _position$coords = position.coords, latitude = _position$coords.latitude, longitude = _position$coords.longitude, accuracy = _position$coords.accuracy;
                      accessToken = process.env.VUE_APP_MAPBOX_ACCESS_TOKEN;
                      geocodingUrl = process.env.VUE_APP_MAPBOX_GEOCODING_API_URL;
                      endpoint = "".concat(geocodingUrl, "/mapbox.places/").concat(longitude, ",").concat(latitude, ".json");
                      params = new URLSearchParams({
                        access_token: accessToken,
                        types: "address",
                        limit: 1,
                        proximity: "".concat(longitude, ",").concat(latitude)
                      });
                      _context2.next = 8;
                      return fetch("".concat(endpoint, "?").concat(params));
                    case 8:
                      response = _context2.sent;
                      _context2.next = 11;
                      return response.json();
                    case 11:
                      data = _context2.sent;
                      if (data.features && data.features.length > 0) {
                        resolve(data.features[0]);
                      } else {
                        reject(new Error("No address found for current position"));
                      }
                      _context2.next = 19;
                      break;
                    case 15:
                      _context2.prev = 15;
                      _context2.t0 = _context2["catch"](0);
                      console.error("Error in reverse geocoding:", _context2.t0);
                      reject(_context2.t0);
                    case 19:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2, null, [[0, 15]]);
              }));
              return function (_x2) {
                return _ref.apply(this, arguments);
              };
            }(), function (error) {
              var errorMessage = "Unable to get position";
              switch (error.code) {
                case error.PERMISSION_DENIED:
                  errorMessage = "Location permission denied";
                  break;
                case error.POSITION_UNAVAILABLE:
                  errorMessage = "Location information unavailable";
                  break;
                case error.TIMEOUT:
                  errorMessage = "Location request timed out. Try again or enter address manually.";
                  break;
              }
              reject(new Error(errorMessage));
            }, {
              enableHighAccuracy: true,
              timeout: 30000,
              maximumAge: 0
            });
          }));
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _getCurrentPositionAddress.apply(this, arguments);
}